import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';

const HERO_IMAGE = "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?q=80&w=2070&auto=format&fit=crop";

const companyLogos = [
  { name: 'Federación Patronal', logo: 'https://customer-assets.emergentagent.com/job_06e7508c-1e62-492f-99e4-396c2a55bc67/artifacts/stijlm55_fedderacion%20patronal%20logo.jpeg' },
  { name: 'Mercantil Andina', logo: 'https://customer-assets.emergentagent.com/job_06e7508c-1e62-492f-99e4-396c2a55bc67/artifacts/at6xuu49_%20MERCANTIL%20ANDINA%20logo.png' },
  { name: 'Experta Seguros', logo: 'https://customer-assets.emergentagent.com/job_06e7508c-1e62-492f-99e4-396c2a55bc67/artifacts/tvh2rlre_EXPERTA%20seguros%20logo.png' },
  { name: 'ATM Seguros', logo: 'https://customer-assets.emergentagent.com/job_06e7508c-1e62-492f-99e4-396c2a55bc67/artifacts/lnmk47gc_ATM%20SEGUROS%20logo.webp' },
  { name: 'Rivadavia Seguros', logo: 'https://customer-assets.emergentagent.com/job_06e7508c-1e62-492f-99e4-396c2a55bc67/artifacts/9hd2vmwf_RIVADAVIA%20%20logo.jpg' },
];

export const Hero = ({ onCotizarClick }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % companyLogos.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const scrollToServices = () => {
    const element = document.querySelector('#servicios');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img 
          src={HERO_IMAGE} 
          alt="Montañas" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary/95 via-primary/85 to-primary/70"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-primary/90 via-transparent to-transparent"></div>
      </div>

      {/* Decorative elements */}
      <div className="absolute top-1/4 right-10 w-64 h-64 bg-white/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-1/4 left-10 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>

      {/* Content */}
      <div className="container mx-auto px-4 md:px-6 relative z-10 pt-24 pb-16">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div className="text-white space-y-8 animate-slide-in-up">
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
              <i className="fas fa-shield-alt text-accent"></i>
              <span className="text-sm font-medium">Seguros & Gestoría del Automotor</span>
            </div>
            
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight">
              Tu tranquilidad es{' '}
              <span className="relative">
                <span className="relative z-10">nuestra prioridad</span>
                <span className="absolute bottom-2 left-0 w-full h-3 bg-accent/30 -z-0"></span>
              </span>
            </h1>
            
            <p className="text-lg md:text-xl text-white/80 max-w-xl leading-relaxed">
              Más que una aseguradora, tu socio de confianza. Protegemos lo que más te importa con soluciones personalizadas para particulares y empresas.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button 
                onClick={() => onCotizarClick('individual')}
                size="lg"
                className="bg-white text-primary hover:bg-white/90 font-bold px-8 py-6 text-lg rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
              >
                <i className="fas fa-file-invoice mr-3"></i>
                Pedir Cotización
              </Button>
              
              <Button 
                onClick={scrollToServices}
                variant="outline"
                size="lg"
                className="border-2 border-white/30 text-white bg-white/10 hover:bg-white/20 font-semibold px-8 py-6 text-lg rounded-full backdrop-blur-sm transition-all duration-300"
              >
                <i className="fas fa-arrow-down mr-3"></i>
                Ver Servicios
              </Button>
            </div>

            {/* Trust indicators */}
            <div className="flex flex-wrap items-center gap-8 pt-8 border-t border-white/20">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center">
                  <i className="fas fa-users text-accent text-xl"></i>
                </div>
                <div>
                  <p className="text-2xl font-bold">+1000</p>
                  <p className="text-sm text-white/70">Clientes Satisfechos</p>
                </div>
              </div>
              
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center">
                  <i className="fas fa-clock text-accent text-xl"></i>
                </div>
                <div>
                  <p className="text-2xl font-bold">+15</p>
                  <p className="text-sm text-white/70">Años de Experiencia</p>
                </div>
              </div>
              
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center">
                  <i className="fas fa-file-contract text-accent text-xl"></i>
                </div>
                <div>
                  <p className="text-2xl font-bold">+2000</p>
                  <p className="text-sm text-white/70">Pólizas Activas</p>
                </div>
              </div>
            </div>
          </div>

          {/* Carousel Card - Compañías */}
          <div className="hidden lg:block">
            <div className="relative">
              {/* Main card */}
              <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 border border-white/20 shadow-2xl">
                <div className="text-center mb-6">
                  <h3 className="text-white text-xl font-bold mb-2">
                    ¿Sos productor de seguros?
                  </h3>
                  <p className="text-white/80 text-lg">
                    Si querés formar parte de nuestra organización, ¡contactanos!
                  </p>
                </div>

                <div className="border-t border-white/20 pt-6">
                  <p className="text-white/70 text-sm text-center mb-6 uppercase tracking-wider">
                    Compañías con las que trabajamos
                  </p>
                  
                  {/* Carousel */}
                  <div className="relative h-24 overflow-hidden">
                    <div 
                      className="flex transition-transform duration-500 ease-in-out"
                      style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                    >
                      {companyLogos.map((company, index) => (
                        <div 
                          key={index} 
                          className="min-w-full flex items-center justify-center"
                        >
                          <div className="bg-white rounded-xl p-4 shadow-lg">
                            <img 
                              src={company.logo} 
                              alt={company.name}
                              className="h-16 w-auto max-w-[200px] object-contain"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Dots indicator */}
                  <div className="flex justify-center gap-2 mt-4">
                    {companyLogos.map((_, index) => (
                      <button
                        key={index}
                        onClick={() => setCurrentSlide(index)}
                        className={`w-2 h-2 rounded-full transition-all duration-300 ${
                          currentSlide === index ? 'bg-white w-6' : 'bg-white/40'
                        }`}
                      />
                    ))}
                  </div>

                  {/* All logos grid with names */}
                  <div className="mt-6 grid grid-cols-5 gap-3">
                    {companyLogos.map((company, index) => (
                      <div 
                        key={index}
                        className={`flex flex-col items-center transition-all duration-300 cursor-pointer ${
                          currentSlide === index ? 'scale-105' : 'hover:scale-105'
                        }`}
                        onClick={() => setCurrentSlide(index)}
                      >
                        <div className={`bg-white/90 rounded-lg p-2 w-full ${
                          currentSlide === index ? 'ring-2 ring-accent' : ''
                        }`}>
                          <img 
                            src={company.logo} 
                            alt={company.name}
                            className="h-8 w-full object-contain"
                          />
                        </div>
                        <span className="text-white/70 text-[10px] mt-1 text-center leading-tight">
                          {company.name}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
                
                <Button 
                  onClick={() => onCotizarClick('productor')}
                  className="w-full mt-6 bg-white text-primary hover:bg-white/90 font-semibold rounded-full py-3"
                >
                  <i className="fas fa-handshake mr-2"></i>
                  Quiero ser parte
                </Button>
              </div>

              {/* Floating elements */}
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-8 h-12 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-white rounded-full animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};
